import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 * $el: HTMLElement;
 * $refs: {
 *  content: HTMLElement;
 *};
 * }} BtnProps
 */

/**
 * Select
 * @augments {Base<BtnProps>}
 */
export default class Select extends Base {
  static config = {
    name: 'Select',
    refs: ['dropdown', 'items[]', 'btn', 'selected', 'input', 'label'],
    emits: ['click-item', 'show-dropdown'],
    options: {
      update: {
        type: Number,
        default: 1,
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.$refs.input) {
      const currentValue = this.$refs.input.value;
      if (currentValue && this.$refs.items) {
        this.currentItem = this.$refs.items.find((item) => item.dataset.value === currentValue);
        if (this.currentItem) {
          this.currentItem.classList.add('bg-green/50');
        }
      }
    }
  }

  /**
   * Click on btn to open dropdown
   * @param {object} props
   * @param {Event} props.event
   */
  onBtnClick({ event }) {
    event.stopPropagation();
    this.showDropdown();
  }

  /**
   * When clicking on Dropdown
   * @param {object} props
   * @param {Event} props.event
   */
  onDropdownClick({ event }) {
    event.stopPropagation();
  }

  /**
   *
   */
  showDropdown() {
    this.$refs.dropdown.classList.remove('opacity-0', 'pointer-events-none');
    this.$emit('show-dropdown', this);
  }

  /**
   *
   */
  hideDropdown() {
    this.$refs.dropdown.classList.add('opacity-0', 'pointer-events-none');
  }

  /**
   *
   */
  onDocumentClick() {
    this.hideDropdown();
  }

  /**
   * When clicking on list item
   * @param {object} props
   * @param {number} props.index Current index element.
   */
  onItemsClick({ index }) {
    this.setItemActive(index);
    this.hideDropdown();
    this.$emit('click-item', index);
  }

  /**
   * Active item
   * @param {number} index index of element to set
   */
  setItemActive(index) {
    if (this.currentItem) {
      this.currentItem.classList.remove('bg-green/50');
    }

    this.currentItem = this.$refs.items[index];

    if (this.$refs.input) {
      this.$refs.input.value = this.currentItem.dataset.value;
    }

    if (this.$options.update) {
      this.$refs.label.innerHTML = this.currentItem.innerHTML;
    }
    this.currentItem.classList.add('bg-green/50');
  }
}
